import { Fragment } from "react";

import Timer from "@/design/components/Timer";

import { Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import PropTypes from "prop-types";

function CallerTab({ calls }) {
  return (
    <List sx={{ gap: 0 }}>
      {calls.length > 0 ? (
        calls.map((call, key) => {
          const callTime = new Date(call.Time ?? call.TimeReceived) / 1000;

          return (
            <Fragment key={key}>
              {key >= 1 && (
                <Divider
                  variant="inset"
                  component="li"
                  sx={{ listStyle: "none", mx: 2, borderColor: (theme) => theme.vars.palette.divider }}
                />
              )}
              <ListItem
                sx={{
                  minHeight: 36,
                  py: 0.5,
                }}
              >
                <ListItemText
                  primary={
                    <>
                      {call.CallerIDNum}
                      {call.CallerIDName !== "<unknown>" && (
                        <Typography
                          sx={{ opacity: ".6", display: "inline", fontSize: 13 }}
                        >{` ${call.CallerIDName}`}</Typography>
                      )}
                    </>
                  }
                />
                <ListItemIcon sx={{ justifyContent: "flex-end", pr: 0, py: 0 }}>
                  <Typography
                    sx={{ fontSize: ".75rem", minWidth: 0, fontVariantNumeric: "tabular-nums" }}
                    color="textSecondary"
                  >
                    <Timer startTime={callTime} />
                  </Typography>
                </ListItemIcon>
              </ListItem>
            </Fragment>
          );
        })
      ) : (
        <ListItem
          sx={{
            minHeight: 36,
            py: 0.5,
          }}
        >
          <ListItemText primary="No callers in queue" />
        </ListItem>
      )}
    </List>
  );
}

CallerTab.propTypes = {
  calls: PropTypes.array,
};

export default CallerTab;
